import type { AlertProps } from '@nuxt/ui'

const alertOrangeIcon: NonNullable<AlertProps['ui']> = {
  title: 'font-bold',
  icon: 'text-yellow-500',
}

const alertOrangeIconMobile: NonNullable<AlertProps['ui']> = {
  ...alertOrangeIcon,
  root: 'lg:hidden',
}

const alertOrangeIconDesktop: NonNullable<AlertProps['ui']> = {
  ...alertOrangeIcon,
  root: 'hidden lg:flex',
}

export { alertOrangeIcon, alertOrangeIconMobile, alertOrangeIconDesktop }
